import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@vr/lib';
import { IconButton } from '@material-ui/core';
import { useSelector } from 'react-redux';
import ContactComponent from './Contact';
import devices from '~/styles/devices';
import { VRPAT } from '~/config/constants';

const CloseButton = styled(IconButton)`
  z-index: 1;

  &.MuiButtonBase-root {
    position: absolute;
    right: 16px;
    top: -20px;
    width: 40px;
    height: 40px;
    font-size: 20px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
    outline: none;
    &,
    &:hover {
      background: ${({ theme }) => theme.colors.white};
    }
  }
`;

const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 20px 20px 0 0;
  position: fixed;
  transform: translateY(${window.innerHeight + 300}px);
  transition: transform 0.3s linear;
  width: 100%;
  height: ${({ issuer }) => (issuer === VRPAT ? '90vh' : '78vh')};
  max-height: 583px;
  z-index: 9999;
  bottom: 0;
  box-shadow: 0 0 8px #00000022;

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: translateY(0);
    `};

  @media (min-width: ${devices.tablet}) {
    max-width: 375px;
    right: 0;
    bottom: 0;
  }
  @media (min-width: ${devices?.desktop}) {
    right: 60px;
    bottom: 20px;
  }
`;
const Header = styled.div`
  padding: 32px 0 18px;
  background-color: ${({ theme }) => theme.colors.institucional};
  border-radius: 15px 15px 0 0;
`;
const Title = styled.h2`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 54px;
  border-left: 19px solid ${({ theme }) => theme.colors.secondary};
  padding-left: 10px;

  @media (min-width: ${devices.tablet}) {
    font-size: 3rem;
  }
`;
const Description = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
  margin: 19px auto 0;
`;
const Body = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 27px 18px;
  overflow-y: auto;
  height: 335px;

  @media (min-height: 610px) {
    height: unset;
  }

  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.secondary}
    ${({ theme }) => theme.colors.gray100};
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  ::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.secondary};
    border: 0px none ${({ theme }) => theme.colors.white};
    border-radius: 50px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.secondary};
  }
  ::-webkit-scrollbar-thumb:active {
    background: ${({ theme }) => theme.colors.secondary};
  }
  ::-webkit-scrollbar-track {
    background: #cccccc;
    border: 17px none ${({ theme }) => theme.colors.white};
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track:hover {
    background: #cccccc;
  }
  ::-webkit-scrollbar-track:active {
    background: #cccccc;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
const Contact = styled(ContactComponent)`
  margin-bottom: 30px;
`;

export default function Help({ open, closeHelp }) {
  const issuer = useSelector(state => state?.issuer?.name);
  const phones = useSelector(state => state?.issuer?.phones);
  return createPortal(
    <Container isOpen={open} issuer={issuer}>
      <CloseButton
        onClick={() => closeHelp()}
        color="primary"
        data-testid="close-button"
      >
        <FontAwesomeIcon icon={['fas', 'times']} />
      </CloseButton>
      <div>
        <Header>
          <Title>atendimento</Title>
          <Description>
            Ainda com dúvidas? Fale com um de
            <br /> nossos atendentes!
          </Description>
        </Header>
        <Body>
          {phones && phones.map(it => <Contact type={it.type} data={it} />)}
        </Body>
      </div>
    </Container>,
    document.body,
  );
}

Help.propTypes = {
  open: PropTypes.bool.isRequired,
  closeHelp: PropTypes.func.isRequired,
};
